export default __webpack_public_path__ + "static/Amy_Yai-6db2bc05572f39725a11b2b213da76d0.jpeg";